import { create } from 'zustand';
import type { SiteTerrainSurface } from './terrainMath';

export interface SiteTerrainEntry {
  status: 'loading' | 'ready' | 'unavailable';
  surface?: SiteTerrainSurface;
  error?: string;
}
export const useSiteTerrain = create<{ entries: Record<string, SiteTerrainEntry> }>(() => ({ entries: {} }));
export function setSiteTerrain(id: string, entry: SiteTerrainEntry) {
  useSiteTerrain.setState((s) => ({ entries: { ...s.entries, [id]: entry } }));
}
